// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const DID_YOU_DO_IT_BY_ERROR = "Bol to omyl?";
export const MAIL_subject_WAS_MARKED_AS_SPAM = "Spr\u00e1va \"%(subject)s\" bola zmazan\u00e1 a zaslan\u00e1 k n\u00e1m ako spam.";
export const number_MESSAGES_WAS_DELETED = ["%(number)s spr\u00e1va bola zmazan\u00e1", "%(number)s spr\u00e1vy boli zmazan\u00e9", "%(number)s spr\u00e1v bolo zmazan\u00fdch"];
